import React, { useState, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import CategoryGrid from '../components/Home/CategoryGrid';
import RecentOrders from '../components/Home/RecentOrders';
import CurrentOrder from '../components/Home/CurrentOrder';
import cafeImage from '../imagenes/boton-cafe.png';
import smoothiesImage from '../imagenes/boton-smoothies.png';
import bakeryImage from '../imagenes/boton-bakery.png';
import saladsImage from '../imagenes/boton-ensalada.png';
import './HomePage.css';

const HomePage = ({ onNavigateToMenu, onTrackOrder, currentOrder }) => {
  const { user } = useAuth();
  const { recentOrders, cartItems } = useCart();
  const [userPhoto, setUserPhoto] = useState('🙋🏾‍♂️');
  const fileInputRef = useRef(null);

  const categories = [
    { id: 'coffee', name: 'Coffee', backgroundImage: cafeImage },
    { id: 'smoothies', name: 'Smoothies', backgroundImage: smoothiesImage },
    { id: 'bakery', name: 'Bakery', backgroundImage: bakeryImage },
    { id: 'salads', name: 'Salads', backgroundImage: saladsImage }
  ];

  const handleCategoryClick = (categoryId) => {
    if (onNavigateToMenu) {
      onNavigateToMenu(categoryId);
    }
  };

  const handleEmojiClick = () => {
    const emojis = ['😁', '😎', '😜', '😱', '👩🏾', '👻', '👤', '🤵🏾‍♂️', '🤦🏾‍♂️', '🙋🏾‍♂️', '👾', '☕', '💀'];
    const randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];
    setUserPhoto(randomEmoji);
  };

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setUserPhoto(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const isImage = (photo) => {
    return photo.startsWith('data:image') || photo.startsWith('http');
  };

  return (
    <div className="home-page">
      {/* Header con bienvenida y foto de usuario */}
      <header className="home-header">
        <div className="user-greeting">
          <div className="user-photo-container">
            <div
              className={`user-photo ${isImage(userPhoto) ? 'image-mode' : ''}`}
              onClick={handleEmojiClick}
              style={isImage(userPhoto) ? { backgroundImage: `url(${userPhoto})`, fontSize: 0 } : {}}
            >
              {!isImage(userPhoto) && userPhoto}
            </div>
            <button className="change-photo-btn" onClick={handleEditClick}>
              ✎
            </button>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept="image/*"
              onChange={handleFileChange}
            />
          </div>
          <div className="greeting-text">
            <h1>{user?.name || 'Dante Moss'}</h1>
            <h2>¡Hola!</h2>
            <p>¿Qué te gustaría elegir hoy para hacer tu día más feliz?</p>
          </div>
        </div>
      </header>

      {/* Orden actual si existe */}
      {currentOrder ? (
        <div className="order-ready-card">
          <h3>🎉 Tu pedido esta listo!</h3>
          <div className="order-ready-details">
            <p><strong>Pedido #{currentOrder.id}</strong></p>
            <p>Total: ${currentOrder.total?.toFixed(2)}</p>
            <p>Pickup: {currentOrder.store?.name}</p>
            <button
              className="view-qr-btn"
              onClick={() => {
                // Mostrar QR de nuevo
                alert(`Show QR code for order #${currentOrder.id}`);
              }}
            >
              Código QR
            </button>
          </div>
        </div>
      ) : cartItems.length > 0 ? (
        <CurrentOrder
          cartItems={cartItems}
          onTrackOrder={onTrackOrder}
        />
      ) : null}

      {/* Grid de categorías */}
      <section className="categories-section">
        <h3>Categorias</h3>
        <CategoryGrid
          categories={categories}
          onCategoryClick={handleCategoryClick}
        />
      </section>

      {/* Órdenes recientes */}
      {recentOrders.length > 0 && (
        <RecentOrders orders={recentOrders} limit={2} title="Recientes pedidos" />
      )}

      {/* Promoción */}
      <section className="promo-section">
        <div className="promo-card">
          <h3>¡Agárralo y listo!</h3>
          <p>¿POR QUÉ ESPERAR CUANDO PUEDES ORDENAR, RECOGER Y LLEVAR?</p>
          <a
            href="https://test.marketdynamo.com/cafe-moctezuma-express/landing-cafe-moctezuma/index.html#hero"
            target="_blank"
            rel="noopener noreferrer"
            className="website-link"
          >
            www.cafemoctezuma.com
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;